import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAppContext } from "../Contexts/AppContext";
import MmenuLight from 'mmenu-light';
import Constants from '../Utilities/Constants';
import 'mmenu-light/dist/mmenu-light.css';
import '../css/custom.css';


const SmartMenu = () => {
  const { customer, setShowLoginModal } = useAppContext();
  const navigate = useNavigate();
  const showLoginRef = React.useRef(setShowLoginModal);
  showLoginRef.current = setShowLoginModal;

  useLayoutEffect(() => {
        const menuElement = document.querySelector("#menu");
        if (!menuElement) return;

        const menu = new MmenuLight(menuElement);
        menu.navigation({
          slidingSubmenus: false,
          title: 'תפריט'});
        const drawer = menu.offcanvas({
          position: 'right'
         });

        // Native handler for login — bypasses mmenu-light's stopPropagation
        const loginEl = menuElement.querySelector('.m-login');
        const loginHandler = (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          try { drawer.close(); } catch(e) {}
          showLoginRef.current?.(true);
        };
        if (loginEl) loginEl.addEventListener('click', loginHandler, true);

        // Open menu when button is clicked
        const openMenuAnchor = document.querySelector('a[href="#menu"]');
        const openMenuHandler = (event) => {
            event.preventDefault();
            drawer.open();
        };
        if (openMenuAnchor) openMenuAnchor.addEventListener('click', openMenuHandler);

        // Intercept menu links rendered by mmenu-light and force SPA navigation.
        // Use capture phase so this runs before mmenu-light's own bubble-phase handler,
        // preventing mmenu-light from triggering a full-page reload on mobile.
        const onMenuClick = (ev) => {
          const anchor = ev.target.closest('a[href]');
          if (!anchor) return;

          const isInsideSmartMenu = anchor.closest('#menu, .mm-ocd');
          if (!isInsideSmartMenu) return;

          const href = anchor.getAttribute('href');
          if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) {
            return;
          }

          const target = anchor.getAttribute('target');
          if (target && target !== '_self') return;

          const parsed = new URL(href, window.location.origin);
          if (parsed.origin !== window.location.origin) return;

          ev.preventDefault();
          ev.stopImmediatePropagation();
          try { drawer.close(); } catch (e) {}
          navigate(`${parsed.pathname}${parsed.search}${parsed.hash}`);
        };
        document.addEventListener('click', onMenuClick, true);

        // Clean up event listeners on component unmount
        return () => {
            if (loginEl) loginEl.removeEventListener('click', loginHandler, true);
            if (openMenuAnchor) openMenuAnchor.removeEventListener('click', openMenuHandler);
            document.removeEventListener('click', onMenuClick, true);
        };
      }, [navigate]);

    return (
      <NavBar business={customer && customer.business} customer={customer} />
    );
};

const NavBar = ({business, customer}) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
      
      async function getCategories () {
          const url = Constants.API_URL_GET_CATEGORIES;
          var api = url;
  
          if (business) {
              api = `${url}?b=true`;
          }
  
          await fetch(api, { headers: { 'X-Api-Key': Constants.API_KEY } })
              .then(response => response.json())
              .then(data => setCategories(data));
      }

      getCategories();

      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [business])

  return (
    <nav id="menu" aria-hidden="true" className='mm-menu'>
        <ul>
          <li className='no-arrow'>
            {customer
              ? <span className="p-3">
                  {customer.picture
                    ? <img src={customer.picture} alt={customer.customerName} width="28" height="28" style={{borderRadius:'50%', objectFit:'cover'}} />
                    : ''
                  }
                  &nbsp;&nbsp;{customer.customerName}
                </span>
              : 
              <span className="m-login mm-listitem__text" >
                  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user" className="svg-inline--fa fa-user fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 448 512"><path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"></path></svg>
                  &nbsp;&nbsp;כניסה לחשבון&nbsp;
                  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="angle-left" className="svg-inline--fa fa-angle-left fa-w-8" role="img" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 256 512"><path fill="currentColor" d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"></path></svg> 
              </span>
            }
          </li>
          <li className="icons-panel mm-listitem w-100 d-flex justify-content-between">
              <Link to="/Page/אזורי-משלוח" className="top mm-listitem__text col">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="truck" className="svg-inline--fa fa-truck fa-w-20" role="img" xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 640 512"><path fill="currentColor" d="M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"></path></svg>
                <br />
                <span>אזורי משלוח</span>
              </Link>
              <Link to="/Profile" className="top mm-listitem__text col" >                
                <svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 -960 960 960" width="25px" fill="#1f1f1f"><path d="M367-527q-47-47-47-113t47-113q47-47 113-47t113 47q47 47 47 113t-47 113q-47 47-113 47t-113-47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm296.5-343.5Q560-607 560-640t-23.5-56.5Q513-720 480-720t-56.5 23.5Q400-673 400-640t23.5 56.5Q447-560 480-560t56.5-23.5ZM480-640Zm0 400Z"/></svg>
                <br />
                <span>אזור אישי</span>
              </Link>
              <Link to="/Category/sale" className="top mm-listitem__text col">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bullhorn" className="svg-inline--fa fa-bullhorn fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" width="25" height="20" viewBox="0 0 576 512"><path fill="currentColor" d="M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"></path></svg>
                <br /><span>מבצעי השבוע</span>
              </Link>
          </li>
          <li>
              <Link className="nav-sale" to={{pathname:`/Category/sale`}}>מבצעי השבוע</Link>
          </li>
          {customer &&
          <li>
              <Link className="nav-sale" to={{pathname:`/Category/MyProducts`}}>המוצרים שלי</Link>
          </li>
          }
          {
              categories.map((item, index) => (
                <li key={index}>
                      <Link to={{pathname:`/Category/${item.categoryUrl}`}}>{item.categoryName}</Link>
                      <ul className='drop-down'>
                          <div className="clearfix column-2">
                          {
                              item.subCategories.map((node, idx) => (
                                  <li  key={idx}>
                                      <div className="drop_link">
                                          <Link className="dropdown-item" to={{pathname:`/Category/${item.categoryUrl}/${node.subCategoryUrl}`}}>{node.subCategoryName}</Link>
                                      </div>
                                  </li>
                              ))
                          }
                          </div>
                      </ul>
                </li>
              ))
          }
         <li>
              <Link className="m-link" to={{pathname:`/Page/אודותינו`}} >אודותינו</Link>
          </li>

         <li>
              <Link className="m-link" to={{pathname:`/Page/אזורי-חלוקה`}}>אזורי חלוקה ומשלוח</Link>
          </li>

          <li>
              <Link className="m-link" to={{pathname:`/Page/שירות-לקוחות`}}>שירות לקוחות</Link>
          </li>

        </ul>
    </nav>
  )
}


export default SmartMenu;
